import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  robots,
  author,
  publisher,
  schema,
}) {
  return (
    <Helmet>
      {title && <title>{title}</title>}

      {description && (
        <meta name="description" content={description} />
      )}

      {keywords && (
        <meta name="keywords" content={keywords} />
      )}

      {canonical && (
        <link rel="canonical" href={canonical} />
      )}

      {robots && (
        <meta name="robots" content={robots} />
      )}

      {author && (
        <meta name="author" content={author} />
      )}

      {publisher && (
        <meta name="publisher" content={publisher} />
      )}

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
